// Vehicle-specific modules (loaded on single-vehicle pages)
import './vehicle-finance-calculator.js';
import './vehicle-feature-search.js';
import './vehicle-photoswipe.js';

// Global modules (loaded on all pages)
import initCookieConsent    from './cookie-consent.js';
import initHeroStack        from './hero-stack.js';
import initPaymentState     from './payment-state.js';
import initHeroSelect       from './hero-select.js';
import initFaqAccordion     from './faq-accordion.js';
import initDataCarousel     from './data-carousel.js';
import initBrandModelFilter from './brand-model-filter.js';

document.addEventListener('DOMContentLoaded', () => {
  initCookieConsent();
  initHeroStack();
  initPaymentState();
  initHeroSelect();
  initFaqAccordion();
  initDataCarousel();
  initBrandModelFilter();
});
